import React, { VFC } from 'react'

import { useSnackbar as useNotiSnackbar } from 'notistack'

import { Toast } from 'src/components/atoms'

type Props = {
  id: string | number
  text: string | React.ReactNode
  icon?: React.ReactNode
  forwardRef?: React.ForwardedRef<any>
  showCloseIcon?: boolean
}

const BaseCorrectToast: VFC<Props> = ({ id, forwardRef, text, icon, showCloseIcon }) => {
  const { closeSnackbar } = useNotiSnackbar()
  return (
    <Toast
      ref={forwardRef}
      text={text}
      icon={icon}
      showCloseIcon={showCloseIcon}
      type="correct"
      onClickClose={() => closeSnackbar(id)}
    />
  )
}

// MUIのsnackbarでSlideを使用する場合にforwardRefを使用する必要がある
export const CorrectToast = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  return <BaseCorrectToast {...props} forwardRef={ref} />
})
